import request from 'api/request';

export default function updateShiftRoute({ id, ...data }) {
  return request({ url: `/shifts/${id}`, method: 'PUT', data });
}
